module.exports = __webpack_public_path__ + "static/media/finolex.f24d3fa4.png";